import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { setFeatureFlags } from '../../state/actions/featureFlags';
import { store } from '../../state/store';
import FeatureFlagsProvider from './FeatureFlagsProvider';

var featureFlagsCallBack = function featureFlagsCallBack(featureFlagsResponse) {
  return store.dispatch(setFeatureFlags(featureFlagsResponse));
};

var handleFeatureFlagsStore = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(provider, playerId) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", FeatureFlagsProvider(provider, playerId, featureFlagsCallBack));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleFeatureFlagsStore(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default handleFeatureFlagsStore;